import BaseAPI from "./BaseAPI";

class TranslationAPI extends BaseAPI {
	
    get = async (data) => {
        var promise = null;
            promise = await this.init().get("/account/translations");
        return promise;
    };

    store = async (data) => {
        var promise = null;
            promise = await this.init().post("/account/translations", {translation:data});
        return promise;
    };
	
    storeLabels = async (data) => {
        var promise = null;
            promise = await this.init().post("/account/translations", {type:'view', translation:data});
        return promise;
    };
}

export default new TranslationAPI();